import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser"; //

export default function Contact() {
  const form = useRef(); // To reference the form element

  const [isSending, setIsSending] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [error, setError] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    // const form = e.target;
    const formElement = e.target;

    if (!formElement.checkValidity()) {
    formElement.reportValidity();
    return;
  }
    setIsSent(false);
    setError("");
    setIsSending(true);

    // Replace these strings with your actual EmailJS IDs
    const serviceID = "service_zoqlipr";
    const templateID = "template_b2qrhgp";
    const publicKey = "l3USf2X5slReuSrj5";

    emailjs.sendForm(serviceID, templateID, form.current, publicKey)
      .then(() => {
          setIsSending(false); // 4. Reset after success
          setIsSent(true);
          formElement.reset(); // Reset the form fields
      })
     .catch(() => {
          setIsSending(false);
          setIsSent(false);
          setError(
            "We couldn't send your message. Please try again."
        );
      });
  };

  return (
    <div className="min-h-screen bg-white font-sans text-neutral-900 overflow-x-hidden">
      
      {/* 🏛️ Sophisticated Header Section */}
      <section className="relative bg-[#faf9f6] pt-32 pb-48 px-6 text-center">
        <div className="absolute top-10 left-1/2 -translate-x-1/2 pointer-events-none opacity-[0.03] select-none">
          <h1 className="text-[15vw] font-['Playfair_Display'] whitespace-nowrap">CONNECT</h1>
        </div>

        <div className="relative z-10">
          <span className="text-[10px] uppercase tracking-[0.5em] text-rose-300 font-bold mb-4 block">
            Branding & Events Studio
          </span>
          <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl font-normal text-gray-900 tracking-tight">
            Get in <span className="italic text-neutral-700">Touch</span>
          </h1>
          <div className="w-12 h-[1px] bg-neutral-200 mx-auto mt-10" />
          <p className="mt-10 text-neutral-500 max-w-xl mx-auto font-light leading-relaxed text-base md:text-lg">
            Let’s bring your vision to life. Reach out for branding or event planning enquiries.
          </p>
        </div>
      </section>

      {/* 📩 Contact Form */}
      <div className="flex justify-center px-6 -mt-32 pb-32 relative z-20">
        <div className="w-full max-w-4xl bg-white rounded-[3rem] shadow-[0_30px_100px_-20px_rgba(0,0,0,0.08)] border border-neutral-100 p-8 md:p-16">
          
          <form ref={form} onSubmit={sendEmail} className="flex flex-col gap-8">
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="flex flex-col gap-2">
                <label className="text-[10px] uppercase tracking-widest text-neutral-400 ml-1">Full Name</label>
                <input type="text" required name="full_name" className="inputStyle" />
              </div>
              <div className="flex flex-col gap-2">
                <label className="text-[10px] uppercase tracking-widest text-neutral-400 ml-1">Email Address</label>
                <input type="email" required name="email"  className="inputStyle" />
              </div>
              <div className="flex flex-col gap-2">
                <label className="text-[10px] uppercase tracking-widest text-neutral-400 ml-1">Contact Number</label>
                <input type="tel" required name="phone"  pattern="[0-9+() -]+" className="inputStyle" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex flex-col gap-2">
                <label className="text-[10px] uppercase tracking-widest text-neutral-400 ml-1">Enquiry Type</label>
                <select required name="service" className="inputStyle">
                  <option value="">Select Service</option>
                  <option value="Branding">Branding</option>
                  <option value="Wedding Planning">Wedding Planning</option>
                  <option value="Birthday Event">Birthday Event</option>
                  <option value="Corporate Event">Corporate Event</option>
                  <option value="Special Event">Special Event</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="flex flex-col gap-2">
                <label className="text-[10px] uppercase tracking-widest text-neutral-400 ml-1">Event / Delivery Date</label>
                <input type="date" required name="date" className="inputStyle" />
              </div>
            </div>

            <div className="flex flex-col gap-2">
              <label className="text-[10px] uppercase tracking-widest text-neutral-400 ml-1">Project Details</label>
              <textarea required name="message" minLength="10" maxLength="2000" placeholder="Tell us more about your vision..." rows="6" className="textareaStyle" />
            </div>

            

            <div className="flex justify-center mt-6">
              <button 
                type="submit" 
                className={`luxuryButton transition-all duration-300 ${isSending ? 'opacity-50 cursor-not-allowed' : ''}`} 
                disabled={isSending}
              >
                {isSending ? "Sending..." : isSent ? "Sent!" : "Send Message"}
              </button>

              {/* Success message */}
              {isSent && (
                <p className="mt-4 text-center text-sm text-green-600">
                   Thank you! Your enquiry has been sent successfully.
                </p>
           )}

             {/* Error message */}
             {error && (
                 <p className="mt-4 text-center text-sm text-red-500">
                   {error}
                </p>
        )}

            </div>

          </form>
        </div>
      </div>
    </div>
  );
}
